import { LangService } from '@totoplay/toto-core-utilities';
import { TBaseTranslatorResource } from './base.type';

export abstract class BaseTranslator {
  protected namespace: string = 'common';

  protected resources: TBaseTranslatorResource[];

  protected constructor() {
    // prevent outside call
    this.initNameSpace();
    this.builder();
    this.loadResourceBundle();
  }

  public loadResourceBundle() {
    for (let i = 0; i < this.resources.length; i++) {
      const item = this.resources[i];
      LangService.instance().addResourceBundle(item.language, this.namespace, item.resource);
    }
  }

  public initNameSpace() {
    this.namespace = this.constructor.name.toLocaleLowerCase();
  }

  public setResources(resources: TBaseTranslatorResource[]) {
    this.resources = resources;
  }

  public getNameSpace() {
    return this.namespace;
  }

  /**
   * Setting builder for register language resource
   * - Must have steps:
   *    - setResources
   * - Other step below...
   */
  protected abstract builder(): void;
}
